
import { defineComponent, ref } from 'vue';
import Axios from '@/core/services/Http';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { Notify } from '@/core/services';
import { useI18n } from 'vue-i18n';
import InnerLoader from '@/components/InnerLoader.vue';
import { isErplyProvider } from '@/core/helpers/erpProvider';

export default defineComponent({
    name: 'languages',
    components: {
        InnerLoader
    },
    props: {
        erp_enable: Number,
        sync_products_enable: Number
    },
    setup(props) {
        const store = useStore();
        const route = useRoute();
        const i18n = useI18n();
        const reports = ref([]) as Record<any, any>;
        const loading = ref(false);

        const getProducts = () => {
            // if (props.erp_enable == 0 || props.sync_products_enable == 0) {
            //     Notify.error(i18n.t('message.SERVICE_NOT_ENABLED'));
            //     return;
            // }
            store.getters.appInstance.$messageBox
                .confirm(`${i18n.t('message.ARE_YOU_SURE_TO_SYNC_PRODUCTS')}?`, i18n.t('message.INFO'), {
                    confirmButtonText: i18n.t('message.OK'),
                    cancelButtonText: i18n.t('message.CANCEL'),
                    type: 'info'
                })
                .then(async () => {
                    loading.value = true;
                    const startedMessage = i18n.te('message.PRODUCTS_SYNC_STARTED')
                        ? i18n.t('message.PRODUCTS_SYNC_STARTED')
                        : 'Product sync has started.';
                    Notify.success(startedMessage);
                    try {
                        const endpoint = isErplyProvider(store, route.path) ? '/erply/get-products' : '/sap/get-bridge-products';
                        await Axios.get(endpoint);
                    } catch ($e) {
                        Notify.error($e);
                    } finally {
                        loading.value = false;
                    }
                })
                .catch(() => {
                    loading.value = false;
                });
        };

        return {
            reports,
            loading,
            getProducts
        };
    }
});
